'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var styled = require('styled-components');
var notistack = require('notistack');
var styles = require('@mui/material/styles');
var MuiStylesProvider = require('@mui/styles/StylesProvider');
var Grow = require('@mui/material/Grow');
var components_BaseStyle_index = require('../BaseStyle/index.js');
var components_Snackbar_index = require('../Snackbar/index.js');
require('../../tslib.es6-1887e1af.js');
require('../Subtitle2/index.js');
require('../SvgIcon/index.js');
require('../../constants/properties.js');
require('../ButtonText/index.js');
require('../../minus-circle-ca219aaf.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var MuiStylesProvider__default = /*#__PURE__*/_interopDefaultLegacy(MuiStylesProvider);
var Grow__default = /*#__PURE__*/_interopDefaultLegacy(Grow);

var mui_theme = styles.createTheme({
    typography: {
        allVariants: {
            fontFamily: 'TT Commons',
        },
    },
});
var ThemeProvider = function (_a) {
    var theme = _a.theme, children = _a.children;
    return (React__default["default"].createElement(styled.ThemeProvider, { theme: theme },
        React__default["default"].createElement(notistack.SnackbarProvider, { TransitionComponent: Grow__default["default"], anchorOrigin: {
                vertical: 'top',
                horizontal: 'center',
            }, content: function (key, _a) {
                var variant = _a.variant, text = _a.text, action_text = _a.action_text, onActionClick = _a.onActionClick;
                return (React__default["default"].createElement(components_Snackbar_index["default"], { id: key, variant: variant, text: text, action_text: action_text, onActionClick: onActionClick }));
            } },
            React__default["default"].createElement(MuiStylesProvider__default["default"], { injectFirst: true },
                React__default["default"].createElement(styles.StyledEngineProvider, { injectFirst: true },
                    React__default["default"].createElement(styles.ThemeProvider, { theme: mui_theme },
                        React__default["default"].createElement(components_BaseStyle_index["default"], null),
                        children))))));
};
ThemeProvider.propTypes = {
    theme: PropTypes__default["default"].object.isRequired,
    fixed_classnames: PropTypes__default["default"].bool,
};

exports["default"] = ThemeProvider;
